var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgManageDeviceSelected = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.81 0H5.81C4.71 0 3.81 0.9 3.81 2V5H5.81V3H15.81V19H5.81V17H3.81V20C3.81 21.1 4.71 22 5.81 22H15.81C16.91 22 17.81 21.1 17.81 20V2C17.81 0.9 16.91 0 15.81 0ZM3.82 12.47L1.27 9.92L0 11.19L3.81 15L11 7.81L9.73 6.54L3.82 12.47Z",
    fill: "#03002F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82 12.4691L1.27 9.91906L0 11.1891L3.81 14.9991L11 7.80906L9.73 6.53906L3.82 12.4691Z",
    fill: "#C59331"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgManageDeviceSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/manageDeviceSelected.31076d3d18bcfc51fb10d177ff428994.svg";